namespace Portico.Models.Enterprise {
    import pme = Portico.Models.Enterprise;
    import psgm = apigateway.models;
    
    export interface IPatientAccount extends IBaseAccount {
        party: Patient;
    }

    export class PatientAccount extends BaseAccount implements IPatientAccount {
        party: Patient;

        constructor(obj?: PatientAccount | any) {
			super(obj);

			this.party = new Patient();

			if (obj) {
				if (obj.party) {
					this.party = new Patient(obj.party);
				}
			}
        }
        
        mapToEnterpriseCoordinatorPatientAccountUpsearchRequestModel(
            canInsertAccount: boolean, 
            canUpdateAccount: boolean, 
            skipAccountSearch: boolean,
            canInsertParty: boolean, 
            canUpdateParty: boolean, 
            skipPartySearch: boolean,
            sourceId: number,
        ) {
            const accountDiagnosisSession = this.getDiagnosisSession(false);
            const accountUpsearchModel: psgm.EnterpriseCoordinatorAccountUpsearchRequestModel = {
                sourceId,
                accountData: this.mapToEnterpriseCoordinatorAccountUpsearchModelWithFlags(canUpdateAccount, canInsertAccount, skipAccountSearch),
                patientData: this.party ? this.party.mapToEnterpriseCoordinatorPatientUpsearchModelWithFlags(canUpdateParty, canInsertParty, skipPartySearch) : null,
                diagnosisSessionData: accountDiagnosisSession ? accountDiagnosisSession.mapToEnterpriseCoordinatorDiagnosisSessionModel() : null,
				hierarchyExternalIdTypes: [],
                payorData : this.payorRelationships ? _.map(this.payorRelationships, pr => {
					return pr.mapToEnterpriseCoordinatorPayorUpsearchModelWithFlags(canInsertParty, canUpdateParty, skipPartySearch);
                }) : [],
                pharmacyData: this.pharmacyRelationships ? _.map(this.pharmacyRelationships, pr => {
					return pr.mapToEnterpriseCoordinatorPharmacyUpsearchModelWithFlags(canInsertParty, canUpdateParty, skipPartySearch);
                }) : [],
                prescriberData: this.prescriberRelationships ? _.map(this.prescriberRelationships, pr => {
					return pr.mapToEnterpriseCoordinatorPrescriberUpsearchModelWithFlags(canInsertParty, canUpdateParty, skipPartySearch);
                }) : [],
                prescriptionData: this.prescriptions ? _.map(this.prescriptions, p => {
					return p.mapToEnterpriseCoordinatorPrescriptionUpsearchModel();
				}) : [],
				siteData: this.siteRelationships ? _.map(this.siteRelationships, sr => {
					return sr.mapToEnterpriseCoordinatorSiteUpsearchModelWithFlags(canInsertParty, canUpdateParty, skipPartySearch);
				}) : [],
				surveySessionData: this.getSurveySessionIds()
            }
            return accountUpsearchModel;
        }
    }

    export interface IPatientAccountRegistration {
		userName: string;
		password: string;
		firstName: string;
		lastName: string;
		dob: Date;
		gender: number;
		zip: string;
		phone: ContactInfo;
		fax: ContactInfo;
        email: ContactInfo;
		sendEmail: boolean;
    }

    export class PatientAccountRegistration implements IPatientAccountRegistration{
		userName: string;
		password: string;
		firstName: string;
		lastName: string;
		dob: Date;
		gender: number;
		zip: string;
		phone: ContactInfo;
		fax: ContactInfo;
		email: ContactInfo;
		sendEmail: boolean;

        constructor(obj: IPatientAccountRegistration) {
			this.userName = '';
			this.password = '';
			this.firstName = '';
			this.lastName = '';
			this.dob = null;
			this.gender = null;
			this.zip = '';
			this.phone = new ContactInfo();
			this.fax = new ContactInfo();
			this.email = new ContactInfo();
			this.sendEmail = false;


            if(obj) {
				this.userName = obj.userName || '';
				this.password = obj.password;
				this.firstName = obj.firstName || '';
				this.lastName = obj.lastName || '';
				this.dob = obj.dob;
				this.gender = obj.gender;
				this.zip = obj.zip || '';
                
                if (obj.phone) {
					this.phone = new ContactInfo(obj.phone);
				}

				if (obj.fax) {
					this.fax = new ContactInfo(obj.fax);
				}

				if (obj.email) {
					this.email = new ContactInfo(obj.email);
				}

				this.sendEmail = obj.sendEmail;
            }
        }
    }
}